// extracted by mini-css-extract-plugin
export default {"main":"EnhancementPage_main__N7CAB","mainWithGradient":"EnhancementPage_mainWithGradient__4C+VR","container":"EnhancementPage_container__fqh0C"};